import { createContext, useContext } from 'react';
import { notifySessionChanged } from './sessionEvents';
import { requestJson } from './requestJson';
export const AccessContext = createContext({admin:false, mode:null, workspaces:[]});
export const useAccess = () => useContext(AccessContext);
export const API = `${process.env.REACT_APP_BACKEND_URL.replace(/\/+$/, '')}/api`;
export const accessRequest = async (path, method='GET', body) => {
  let data;
  try {
    data=await requestJson(`${API}${path}`, {method, headers:body?{'Content-Type':'application/json'}:undefined, body:body?JSON.stringify(body):undefined},
      {timeoutMs:20000,retries:method==='GET'?1:0,label:path.startsWith('/auth/')?'Sign-in':'Access management'});
  } catch(error) {
    if(error.status===401&&!path.startsWith('/auth/'))notifySessionChanged();
    throw error;
  }
  if(method!=='GET'&&path.startsWith('/auth/'))notifySessionChanged();
  return data;
};
export const PROTOTYPES = [{id:'racing',name:'Horse Racing'}, {id:'league',name:'Rugby League'}, {id:'union',name:'Rugby Union & Sevens'}];
export const MODES = {read_only:'Read-only',full:'Full user',presenter:'Presenter / Showcase',module_admin:'Module admin'};
export const roleLabel=access=>({super_admin:'Super admin',module_admin:'Module admin',full_user:'Full user',read_only:'Read-only',presenter:'Presenter'}[access?.account_role||access?.role]||MODES[access?.mode]||'Visitor');
export const canAnalyze=access=>!access?.presentation&&(access?.admin||access?.mode==='full');
export const moduleNavLabel=access=>access?.admin?'All prototypes':access?.workspaces?.length>1?'Assigned prototypes':'My prototype';